import React from 'react';

const SvgComponent = props => (
  <svg id="BeBold" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="M12.8,8.082A5.386,5.386,0,0,1,5.916,1.2.9.9,0,0,0,4.767.054a7.182,7.182,0,1,0,9.18,9.179A.9.9,0,0,0,12.8,8.086v0Z" />
  </svg>
);

export default SvgComponent;
